import logo from '../logo.svg'
import '../App.css'
import { useEffect } from 'react'
import axios from 'axios'
import Navbar from '../component/navbar'

function Orders() {
    // useEffect(() => {
    //   axios
    //       .get("http://46.4.182.111:8080/panel/show_all_users/")
    //       .then((res) => {
    //
    //
    //       })
    //       .catch((error) => {
    //
    //
    //       });
    // }, []);

    return (
        <div className="container">
            <nav className="sidebar">
                <div>
                    <div className="sidebar__logo">
                        <h2 className="sidebar__logo-header">P-B-Q</h2>
                    </div>
                    <ul className="side-nav">
                        <span className="side-nav__header">دسته بندی</span>
                        <li className="side-nav__item ">
                            <svg
                                width={22}
                                height={23}
                                viewBox="0 0 22 23"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.23201 3.4202L9.23239 3.41989C10.2108 2.63408 11.7843 2.63834 12.7781 3.42994C12.7783 3.43005 12.7784 3.43015 12.7785 3.43025L18.7784 8.2301C18.7789 8.23054 18.7795 8.23099 18.78 8.23143C19.1189 8.50835 19.4146 8.94381 19.6058 9.44415C19.7968 9.94409 19.8672 10.4662 19.8014 10.8985L18.6475 17.8037C18.6474 17.8042 18.6473 17.8047 18.6472 17.8052C18.4217 19.0989 17.1608 20.1667 15.8585 20.1667H6.1418C4.81982 20.1667 3.58766 19.1252 3.36227 17.8148C3.36221 17.8145 3.36215 17.8142 3.36209 17.8138L2.20746 10.9043L2.20726 10.9032C2.13345 10.4677 2.19947 9.94466 2.39002 9.44498C2.58055 8.94535 2.87982 8.51038 3.22697 8.2334L3.22784 8.2327L9.23201 3.4202ZM11.0001 18.1876C11.6521 18.1876 12.1876 17.652 12.1876 17.0001V14.2501C12.1876 13.5981 11.6521 13.0626 11.0001 13.0626C10.3482 13.0626 9.81263 13.5981 9.81263 14.2501V17.0001C9.81263 17.652 10.3482 18.1876 11.0001 18.1876Z"
                                    fill="currentColor"
                                    stroke="currentColor"
                                />
                            </svg>
                            <span>داشبورد</span>
                        </li>
                        <li className="side-nav__item">
                            <svg
                                width={22}
                                height={23}
                                viewBox="0 0 22 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6.30664 17.1375V15.24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M11 17.1375V13.3425"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M15.6934 17.1375V11.4358"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M15.6933 5.86255L15.2716 6.35755C12.9341 9.08922 9.79914 11.0234 6.30664 11.8942"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M13.0073 5.86255H15.6932V8.53922"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M8.25016 20.6667H13.7502C18.3335 20.6667 20.1668 18.8334 20.1668 14.25V8.75004C20.1668 4.16671 18.3335 2.33337 13.7502 2.33337H8.25016C3.66683 2.33337 1.8335 4.16671 1.8335 8.75004V14.25C1.8335 18.8334 3.66683 20.6667 8.25016 20.6667Z"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>کاربران</span>
                        </li>
                        <li className="side-nav__item">
                            <svg
                                width={22}
                                height={23}
                                viewBox="0 0 22 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.1668 9.66671V14.25C20.1668 18.8334 18.3335 20.6667 13.7502 20.6667H8.25016C3.66683 20.6667 1.8335 18.8334 1.8335 14.25V8.75004C1.8335 4.16671 3.66683 2.33337 8.25016 2.33337H12.8335"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M20.1668 9.66671H16.5002C13.7502 9.66671 12.8335 8.75004 12.8335 6.00004V2.33337L20.1668 9.66671Z"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6.4165 12.4166H11.9165"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M6.4165 16.0834H10.0832"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>رانندگان</span>
                        </li>
                        <li className="side-nav__item side-nav__item-active">
                            <svg
                                width={22}
                                height={23}
                                viewBox="0 0 22 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.90576 7.32001L10.9999 12.0042L19.0391 7.34748"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M11 20.3092V11.995"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M9.10256 2.77331L4.20757 5.49584C3.0984 6.11001 2.19092 7.64999 2.19092 8.91499V14.0942C2.19092 15.3592 3.0984 16.8992 4.20757 17.5133L9.10256 20.2359C10.1476 20.8134 11.8617 20.8134 12.9067 20.2359L17.8017 17.5133C18.9109 16.8992 19.8184 15.3592 19.8184 14.0942V8.91499C19.8184 7.64999 18.9109 6.11001 17.8017 5.49584L12.9067 2.77331C11.8526 2.18665 10.1476 2.18665 9.10256 2.77331Z"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M15.5834 12.6366V9.28167L6.88428 4.2583"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span>سفارشات</span>
                        </li>
                    </ul>
                </div>
                <ul className="side-nav">
                    <li className="side-nav__item last-item">
                        <svg
                            width={24}
                            height={25}
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.8999 8.05999C9.2099 4.45999 11.0599 2.98999 15.1099 2.98999H15.2399C19.7099 2.98999 21.4999 4.77999 21.4999 9.24999V15.77C21.4999 20.24 19.7099 22.03 15.2399 22.03H15.1099C11.0899 22.03 9.2399 20.58 8.9099 17.04"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M15.0001 12.5H3.62012"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M5.85 9.14999L2.5 12.5L5.85 15.85"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <span>خارج</span>
                    </li>
                </ul>
            </nav>
            <main className="main-content">
                <Navbar />
                <div className="box transaction-box">
                    <div className="header-container">
                        <h3 className="section-header">لیست سفارشات</h3>
                    </div>
                    <table className="transaction-history">
                        <tbody>
                            <tr>
                                <th>نام</th>
                                <th>
                                    آدرس
                                    <svg
                                        width={12}
                                        height={12}
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.96004 4.47498L6.70004 7.73498C6.31504 8.11998 5.68504 8.11998 5.30004 7.73498L2.04004 4.47498"
                                            stroke="#90A3BF"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </th>
                                <th>
                                    تاریخ
                                    <svg
                                        width={12}
                                        height={12}
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.96004 4.47498L6.70004 7.73498C6.31504 8.11998 5.68504 8.11998 5.30004 7.73498L2.04004 4.47498"
                                            stroke="#90A3BF"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </th>
                                <th>
                                    ساعت
                                    <svg
                                        width={12}
                                        height={12}
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.96004 4.47498L6.70004 7.73498C6.31504 8.11998 5.68504 8.11998 5.30004 7.73498L2.04004 4.47498"
                                            stroke="#90A3BF"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </th>
                                <th>
                                    وضعیت
                                    <svg
                                        width={12}
                                        height={12}
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.96004 4.47498L6.70004 7.73498C6.31504 8.11998 5.68504 8.11998 5.30004 7.73498L2.04004 4.47498"
                                            stroke="#90A3BF"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    <svg
                                        width={36}
                                        height={36}
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx={18}
                                            cy={18}
                                            r={18}
                                            fill="#33B938"
                                            fillOpacity="0.1"
                                        />
                                        <path
                                            d="M24.875 21.8125V23.875H11.125V21.8125C11.125 21.4344 11.4344 21.125 11.8125 21.125H24.1875C24.5656 21.125 24.875 21.4344 24.875 21.8125Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                            strokeWidth="1.5"
                                            strokeMiterlimit={10}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M13.6875 20.625V16.8125H14.0625V20.625H13.6875Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                        />
                                        <path
                                            d="M16.4375 20.625V16.8125H16.8125V20.625H16.4375Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                        />
                                        <path
                                            d="M19.1875 20.625V16.8125H19.5625V20.625H19.1875Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                        />
                                        <path
                                            d="M21.9375 20.625V16.8125H22.3125V20.625H21.9375Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                        />
                                        <path
                                            d="M25.5625 23.8906H10.4375C10.4367 23.8906 10.436 23.8905 10.4346 23.89C10.4328 23.8892 10.4302 23.8876 10.4275 23.885C10.4249 23.8823 10.4233 23.8797 10.4225 23.8779C10.422 23.8765 10.4219 23.8758 10.4219 23.875C10.4219 23.8742 10.422 23.8735 10.4225 23.8721C10.4233 23.8703 10.4249 23.8677 10.4275 23.865C10.4302 23.8624 10.4328 23.8608 10.4346 23.86C10.436 23.8595 10.4367 23.8594 10.4375 23.8594H25.5625C25.5633 23.8594 25.564 23.8595 25.5654 23.86C25.5672 23.8608 25.5698 23.8624 25.5725 23.865C25.5751 23.8677 25.5767 23.8703 25.5775 23.8721C25.578 23.8735 25.5781 23.8742 25.5781 23.875C25.5781 23.8758 25.578 23.8765 25.5775 23.8779C25.5767 23.8797 25.5751 23.8823 25.5725 23.885C25.5698 23.8876 25.5672 23.8892 25.5654 23.89C25.564 23.8905 25.5633 23.8906 25.5625 23.8906Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                        />
                                        <path
                                            d="M18.058 10.691C18.0659 10.6923 18.0707 10.6934 18.0725 10.6939L24.2562 13.1674C24.2675 13.1719 24.302 13.1932 24.335 13.2419C24.368 13.2904 24.375 13.33 24.375 13.3425V15.625C24.375 15.727 24.2895 15.8125 24.1875 15.8125H11.8125C11.7105 15.8125 11.625 15.727 11.625 15.625V13.3425C11.625 13.33 11.632 13.2904 11.665 13.2419C11.698 13.1932 11.7325 13.1719 11.7438 13.1674L17.9275 10.6939C17.9293 10.6934 17.9341 10.6923 17.942 10.691C17.9573 10.6886 17.9775 10.6869 18 10.6869C18.0225 10.6869 18.0427 10.6886 18.058 10.691ZM16.4688 13.5625C16.4688 14.4093 17.1532 15.0938 18 15.0938C18.8468 15.0938 19.5312 14.4093 19.5312 13.5625C19.5312 12.7157 18.8468 12.0313 18 12.0313C17.1532 12.0313 16.4688 12.7157 16.4688 13.5625Z"
                                            fill="#33B938"
                                            stroke="#33B938"
                                        />
                                    </svg>
                                    حسن صفدری
                                </td>
                                <td>همدان - خ قهرمان - ساختمان متین</td>
                                <td>۱۴۰۲/۶/۳۰</td>
                                <td>18 | 20</td>{' '}
                                <td>
                                    <svg
                                        className="status"
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width={16}
                                            height={16}
                                            rx={8}
                                            fill="#BCE455"
                                            fillOpacity="0.3"
                                        />
                                        <circle
                                            cx={8}
                                            cy={8}
                                            r={4}
                                            fill="#7FB519"
                                        />
                                    </svg>
                                    Completed
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <svg
                                        width={36}
                                        height={36}
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx={18}
                                            cy={18}
                                            r={18}
                                            fill="#EBF4FF"
                                        />
                                        <g clipPath="url(#clip0_129_9482)">
                                            <path
                                                d="M23.9945 10.0539C23.0966 9.03042 21.4735 8.59164 19.3971 8.59164H13.3706C13.1652 8.59165 12.9665 8.66495 12.8102 8.79835C12.654 8.93176 12.5505 9.11653 12.5183 9.31943L10.009 25.234C9.95908 25.5479 10.2021 25.832 10.5202 25.832H14.2407L15.1751 19.9054L15.1461 20.091C15.2126 19.6721 15.5709 19.3631 15.9952 19.3631H17.7632C21.2364 19.3631 23.9559 17.9524 24.7504 13.8714C24.7739 13.7507 24.7944 13.6333 24.812 13.5185C24.7118 13.4654 24.7118 13.4654 24.812 13.5185C25.0486 12.0101 24.8104 10.9834 23.9945 10.0539Z"
                                                fill="#27346A"
                                            />
                                            <path
                                                d="M16.5987 12.9751C16.7004 12.9267 16.8116 12.9016 16.9243 12.9017H21.6489C22.2084 12.9017 22.7302 12.9381 23.2071 13.0148C23.3405 13.0361 23.4733 13.0615 23.6051 13.091C23.792 13.1322 23.9768 13.1827 24.1587 13.2422C24.3931 13.3205 24.6114 13.4117 24.8121 13.5185C25.0486 12.0096 24.8104 10.9834 23.9945 10.0539C23.0961 9.03042 21.4735 8.59164 19.3971 8.59164H13.3701C12.9458 8.59164 12.5848 8.90057 12.5183 9.31943L10.009 25.2335C9.95908 25.5478 10.2021 25.8316 10.5196 25.8316H14.2407L16.1792 13.5383C16.1983 13.4175 16.2464 13.3031 16.3195 13.205C16.3926 13.1069 16.4884 13.028 16.5987 12.9751Z"
                                                fill="#27346A"
                                            />
                                            <path
                                                d="M24.7503 13.8714C23.9559 17.9518 21.2364 19.3631 17.7632 19.3631H15.9947C15.5704 19.3631 15.212 19.6721 15.1461 20.091L13.9837 27.4601C13.9402 27.7347 14.1526 27.9836 14.4305 27.9836H17.5668C17.7465 27.9835 17.9202 27.9194 18.0568 27.8027C18.1934 27.686 18.2839 27.5244 18.3119 27.3469L18.3425 27.1871L18.9336 23.4408L18.9717 23.2338C18.9997 23.0563 19.0902 22.8947 19.2268 22.778C19.3634 22.6613 19.5371 22.5971 19.7167 22.5971H20.1861C23.2243 22.5971 25.6032 21.3628 26.2984 17.7931C26.5886 16.3013 26.4384 15.0558 25.6708 14.1809C25.438 13.916 25.1488 13.6971 24.812 13.5185C24.7938 13.6338 24.774 13.7507 24.7503 13.8714Z"
                                                fill="#2790C3"
                                            />
                                            <path
                                                d="M23.98 13.187C23.8562 13.1508 23.7311 13.1188 23.6051 13.091C23.4732 13.062 23.3405 13.0368 23.2071 13.0154C22.7297 12.9381 22.2083 12.9016 21.6483 12.9016H16.9242C16.8115 12.9014 16.7002 12.9267 16.5986 12.9757C16.4882 13.0284 16.3923 13.1072 16.3192 13.2053C16.2461 13.3035 16.198 13.418 16.1791 13.5389L15.175 19.9054L15.146 20.091C15.212 19.6721 15.5703 19.3631 15.9947 19.3631H17.7632C21.2364 19.3631 23.9559 17.9524 24.7503 13.8714C24.7739 13.7507 24.7938 13.6338 24.812 13.5185C24.6108 13.4123 24.3931 13.3205 24.1586 13.2428C24.0994 13.2231 24.0399 13.2046 23.9801 13.187"
                                                fill="#1F264F"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_129_9482">
                                                <rect
                                                    width="16.4967"
                                                    height="19.4609"
                                                    fill="white"
                                                    transform="translate(10 8.53906)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    موسوی
                                </td>
                                <td>همدان - خ سعیدیه - ساختمان لوکس</td>
                                <td>۱۴۰۲/۶/۳۱</td>
                                <td>9 | 11</td>
                                <td>
                                    <svg
                                        className="status"
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width={16}
                                            height={16}
                                            rx={8}
                                            fill="#DBA32A"
                                            fillOpacity="0.14"
                                        />
                                        <circle
                                            cx={8}
                                            cy={8}
                                            r={4}
                                            fill="#DBA32A"
                                        />
                                    </svg>
                                    Pending
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <svg
                                        width={36}
                                        height={36}
                                        viewBox="0 0 36 36"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx={18}
                                            cy={18}
                                            r={18}
                                            fill="#EAECF1"
                                        />
                                        <g clipPath="url(#clip0_129_9497)">
                                            <path
                                                d="M14.6667 30C16.6907 30 18.3333 28.3573 18.3333 26.3333V22.6667H14.6667C12.6427 22.6667 11 24.3093 11 26.3333C11 28.3573 12.6427 30 14.6667 30Z"
                                                fill="#0ACF83"
                                            />
                                            <path
                                                d="M11 19C11 16.976 12.6427 15.3333 14.6667 15.3333H18.3333V22.6667H14.6667C12.6427 22.6667 11 21.024 11 19Z"
                                                fill="#A259FF"
                                            />
                                            <path
                                                d="M11 11.6667C11 9.64267 12.6427 8 14.6667 8H18.3333V15.3333H14.6667C12.6427 15.3333 11 13.6907 11 11.6667Z"
                                                fill="#F24E1E"
                                            />
                                            <path
                                                d="M18.3335 8H22.0002C24.0242 8 25.6668 9.64267 25.6668 11.6667C25.6668 13.6907 24.0242 15.3333 22.0002 15.3333H18.3335V8Z"
                                                fill="#FF7262"
                                            />
                                            <path
                                                d="M25.6668 19C25.6668 21.024 24.0242 22.6667 22.0002 22.6667C19.9762 22.6667 18.3335 21.024 18.3335 19C18.3335 16.976 19.9762 15.3333 22.0002 15.3333C24.0242 15.3333 25.6668 16.976 25.6668 19Z"
                                                fill="#1ABCFE"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_129_9497">
                                                <rect
                                                    width="14.6667"
                                                    height={22}
                                                    fill="white"
                                                    transform="translate(11 8)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    رضا کمالیان
                                </td>
                                <td>همدان - خ میلاد - ساختمان مبین</td>
                                <td>۱۴۰۲/۷/۲۰</td>
                                <td>19 | 21 </td>
                                <td>
                                    <svg
                                        className="status"
                                        width={16}
                                        height={16}
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            width={16}
                                            height={16}
                                            rx={8}
                                            fill="#DB2719"
                                            fillOpacity="0.3"
                                        />
                                        <circle
                                            cx={8}
                                            cy={8}
                                            r={4}
                                            fill="#DB2719"
                                        />
                                    </svg>
                                    On Hold
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </main>
        </div>
    )
}

export default Orders
